import { Box, Divider, Typography } from '@mui/material';
import { Contact, DrawerState, ToggleDrawer } from '../../../../../../model/contacts.model';
import zeplinColor from '../../../../../../theme/Color';
import CustomDrawer from '../../../../CustomDrawer/CustomDrawer';
import { ContactForm } from './ContactForm';

import closeIcon from '../../../../../../assets/close-icon.svg';
import { CompleteOperationType, StartOperationType } from '../../../../../../model/alerts.model';

export function ContactDrawer({
  data,
  fetchContacts,
  drawerState,
  handleToggleDrawer,
  startOperation,
  completeOperation,
}: {
  data?: Contact | undefined;
  fetchContacts?: (accountId: string) => Promise<void>;
  drawerState: DrawerState;
  handleToggleDrawer: ToggleDrawer;
  startOperation: StartOperationType;
  completeOperation: CompleteOperationType;
}) {
  return (
    <CustomDrawer state={drawerState.status} onClose={() => {}}>
      <Box
        sx={{
          width: { xs: '427px', xl: '527px' },
          position: 'relative',
          overflowY: 'scroll',
          height: '100%',
        }}
      >
        <Box
          sx={{
            zIndex: 1000,
            backgroundColor: zeplinColor.Neutral1,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: { xs: '24px 24px 24px 24px', xl: '40px 24px 24px 24px' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                gap: '8px',
                alignItems: 'center',
              }}
            >
              <Typography variant='responsiveHeading2'>{drawerState.type}</Typography>
            </Box>
            <Box>
              <img
                src={closeIcon}
                // className={style.icon}
                alt='close'
                style={{ cursor: 'pointer' }}
                onClick={() => handleToggleDrawer('New Contact')}
              />
            </Box>
          </Box>
          <Divider
            component='div'
            sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }}
          />
          <Box sx={{ padding: '24px 24px 24px 24px', height: '100%' }}>
            <ContactForm
              data={data}
              type={drawerState.type}
              fetchContacts={fetchContacts}
              handleToggleDrawer={handleToggleDrawer}
              startOperation={startOperation}
              completeOperation={completeOperation}
            />
          </Box>
        </Box>
      </Box>
    </CustomDrawer>
  );
}
